import { useCallback, useState } from "react"
import { Block, Button, useStyletron } from "@mezo-org/mezo-clay"

export default function MarketItemAmountPicker({
  amounts,
  onPickAmountCallback,
  keepSelected,
}: {
  amounts: number[]
  onPickAmountCallback: (amount: number) => void
  keepSelected?: boolean
}) {
  const [css, theme] = useStyletron()

  const [selectedAmount, setSelectedAmount] = useState<number>()

  const onPickAmountHandler = useCallback(
    (amount: number) => {
      setSelectedAmount(amount)
      onPickAmountCallback(amount)
    },
    [setSelectedAmount, onPickAmountCallback],
  )

  return (
    <Block
      display="flex"
      flexDirection="row"
      width="100%"
      marginBottom={theme.sizing.scale600}
      className={css({ flexWrap: "wrap" })}
      gridGap={theme.sizing.scale300}
    >
      {amounts
        .sort((a, b) => a - b)
        .map((fixedAmount) => (
          <Button
            key={`pick-amount-${fixedAmount}`}
            shape="pill"
            size="medium"
            kind="secondary"
            isSelected={keepSelected && selectedAmount === fixedAmount}
            onClick={() => onPickAmountHandler(fixedAmount)}
          >
            {fixedAmount} MUSD
          </Button>
        ))}
    </Block>
  )
}
